import Vue from 'vue'
import App from './App.vue'
import './axios'
import router from './routers'
import store from './stores'
import './directive/track'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import * as filters from './utils/filters'
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
import uuid from 'vue-uuid'
import alert from './modules/alert'
import MetaInfo from 'vue-meta-info'
Vue.use(uuid)
Vue.use(alert)
Vue.use(MetaInfo)

Vue.config.productionTip = false


new Vue({
  router,
  store,
  render: h => h(App),
  mounted() {
    setTimeout(() => {
      document.dispatchEvent(new Event('render-event'))
    }, 5000)
  },
}).$mount('#app')


// 顶部进度条
// #nprogress .bar {
//   background: red !important; //自定义颜色
// }
router.beforeEach((to, from, next) => {
  NProgress.start();

  next();
});

router.afterEach(() => {
  NProgress.done();
});